import { render, staticRenderFns } from "./HomeAdvantage.vue?vue&type=template&id=f9d0b2c4&scoped=true&"
import script from "./HomeAdvantage.vue?vue&type=script&lang=js&"
export * from "./HomeAdvantage.vue?vue&type=script&lang=js&"
import style0 from "./HomeAdvantage.vue?vue&type=style&index=0&id=f9d0b2c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d0b2c4",
  null
  
)

export default component.exports